import { render, staticRenderFns } from "./InputSecond.vue?vue&type=template&id=28061e24&"
import script from "./InputSecond.vue?vue&type=script&lang=js&"
export * from "./InputSecond.vue?vue&type=script&lang=js&"
import style0 from "./InputSecond.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports